import React from "react";
import "./Certificate.css";
import Carousel from "react-bootstrap/Carousel";

import sumit from "../images/Sumit.jpg";
import { Button, Container } from "react-bootstrap";
import { Grid } from "@mui/material";

const ReviwData = [
  {
    name: "Sumit Saha",
    date: "07 Feb 2023",
    pic: sumit,
    organization: "Learn With Sumit",
    topic: "Think in a Redux Way",
    comment: `Al Shadab Arnab participated in Learn with Sumit Platform presents "Think in a Redux Way" course and performed very well. He completed all the modules very seriously and participated in most of the quizzes & all the assignments with good results. Learn with Sumit Platform believes he can be a very good resource for any web development company. We wish him continued success in life.`,
    credentials:
      "https://learnwithsumit.com/certificates/verify/LWSCTXN-VICYEVEG",
  },
];

const Certificate = () => {
  return (
    <div className="BG-Certificate" id="certificate">
      <div className="container" style={{ paddingBottom: "50px" }}>
        <div className="after">
          <h1>Certificates and Testimonials</h1>
          <Carousel>
            {ReviwData.map((item) => (
              <Carousel.Item interval={2000}>
                <Container>
                  <Container>
                    <Container>
                      <Container>
                        <div className="certificate-div">
                          <Grid container spacing={4}>
                            <Grid item xs={12} md={12} lg={4}>
                              <div className="certificate-box">
                                <div className="content-box-portfolio">
                                  <img src={item.pic} alt={item.name} />
                                </div>
                                <h3
                                  style={{
                                    marginTop: "8px",

                                    fontWeight: "bold",
                                  }}
                                >
                                  {item.name}
                                </h3>
                                <h5
                                  style={{
                                    marginTop: "8px",
                                  }}
                                >
                                  {item.organization}
                                </h5>
                              </div>
                            </Grid>
                            <Grid xs={12} item lg={7} md={12}>
                              <h4 className="review-icon">"</h4>
                              <div className="content-box-review">
                                <div
                                  style={{
                                    borderBottom:
                                      "1px solid rgb(144, 136, 136)",
                                  }}
                                >
                                  <h2
                                    style={{
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {item.topic}
                                  </h2>
                                  <h6>{item.date}</h6>
                                </div>
                                <div
                                  style={{
                                    marginTop: "20px",
                                    color: "rgb(144, 136, 136)",
                                  }}
                                >
                                  <h6 style={{}}>{item.comment}</h6>
                                </div>
                                <Button variant="success">
                                  <h6>
                                    <a
                                      style={{
                                        textDecoration: "none",
                                        color: "white",
                                      }}
                                      href={item.credentials}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Show Certificate or Credential →
                                    </a>
                                  </h6>
                                </Button>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Container>
                    </Container>
                  </Container>
                </Container>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
